// extracted by mini-css-extract-plugin
export default {"inputItem__wrapper":"Input_inputItem__wrapper__Br2jE","inputItem":"Input_inputItem__cfnQN","inputItem__icon":"Input_inputItem__icon__pjDTz"};